<template>
  <div class="core-bottom-content">
    <div class="top">
      <div class="top-title">
        <div class="tab-item" v-for="(data,index) in itemList" :key="index" @click="changeBg(index)" :class="{'top-crib-title-num-active': data.sign === 1}">
          {{data.title}}
        </div>
      </div>
      <div class="top-select">
        <DropDownNext changeTitle="false" :content="title" :items="selectList" v-on:sendInfo = "showInfo"></DropDownNext>
      </div>
    </div>
    <div class="main-content">
      <transition :name="transitionName">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import DropDownNext from '../../../components/DropDownNext.vue'
export default {
  name: 'HistoryCurve',
  components: { DropDownNext },
  data () {
    return {
      transitionName: 'slide-fade',
      title: '历史曲线',
      itemList: [
        {title: '环境温湿度', sign: 1, path: '/warehouse/historyCurve'}
      ],
      selectList: [
        {title: '实时监控', id: 0},
        {title: '单个传感器曲线', id: 1}
      ]
    }
  },
  created () {
    let value = parseInt(this.$route.query.value)
    if (isNaN(value)) {
      value = 0
    }
    this.itemList.map((data, ind) => {
      if (value === ind) {
        data.sign = 1
      } else {
        data.sign = 0
      }
    })
  },
  watch: {
    '$route' () {
      let value = parseInt(this.$route.query.value)
      if (isNaN(value)) {
        value = 0
      }
      this.itemList.map((data, ind) => {
        if (value === ind) {
          data.sign = 1
        } else {
          data.sign = 0
        }
      })
    }
  },
  methods: {
    showInfo: function (data) {
      let _this = this
      setTimeout(function () {
        console.log(data.id)
        if (data.id === 0) {
          _this.$router.push({
            path: '/warehouse',
            query: {
              index: '3'
            }
          })
        } else if (data.id === 1) {
          _this.$router.push({
            path: '/warehouse/singleCurve',
            query: {
              index: '3'
            }
          })
        }
      }, 0)
    },
    changeBg: function (index) {
      this.itemList.map((data, ind) => {
        if (index === ind) {
          data.sign = 1
          this.$router.push({
            path: data.path,
            query: {
              index: '3',
              value: index
            }
          })
        } else {
          data.sign = 0
        }
      })
    }
  }
}
</script>

<style scoped>
  @import "Warehouse.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/warehouse/WareHistoryCurve.vue